import React from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/noAccess.scss";

const NoAccess = () => {
  const navigate = useNavigate();

  return (
    <div className="noaccess">
      <div className="noaccess__container">
        <p className="noaccess__title">403</p>
        <p className="noaccess__subtitle">Brak dostępu</p>
        <p className="noaccess__message">
          Nie posiadasz wymaganej roli, aby uzyskać dostęp do modułu
          Administracji. Skontaktuj się z administratorem systemu w celu
          uzyskania odpowiednich uprawnień.
        </p>
        <button
          className="noaccess__back-btn"
          onClick={() => navigate("/")}
        >
          Wróć na stronę główną
        </button>
      </div>
    </div>
  );
};

export default NoAccess;
